import { useFeature } from 'src/core/common/hooks/useFeature';
import FEATURES from 'src/core/constants/features';

import { useCustomFieldsQuery } from '../../budgets/apis';
import { type Dimension } from '../approvalWorkflow';

const BASE_DIMENSIONS = ['costCenter', 'team'] as const;

const ADVANCED_DIMENSIONS = [
  ...BASE_DIMENSIONS,
  'spendType',
  'expenseCategory',
] as const;

export const useGetDimensions = (): Dimension[] => {
  const isTeamsFeatureEnabled = useFeature(FEATURES.TEAMS);
  const isCostCentersFeatureEnabled = useFeature(
    FEATURES.COST_CENTERS_ACTIVATED,
  );
  const hasAdvancedApprovalWorkflowFeature = useFeature(
    FEATURES.ADVANCED_APPROVAL_WORKFLOW,
  );
  const isCustomFieldsFeatureEnabled = useFeature(FEATURES.CUSTOM_FIELDS);
  const isExpenseCategoriesFeatureEnabled = useFeature(
    FEATURES.EXPENSE_CATEGORIES,
  );

  const customFieldsQueryState = useCustomFieldsQuery();

  if (!hasAdvancedApprovalWorkflowFeature) {
    return BASE_DIMENSIONS.filter(
      (dimension) =>
        !(dimension === 'team' && !isTeamsFeatureEnabled) &&
        !(dimension === 'costCenter' && !isCostCentersFeatureEnabled),
    ).map((dimension) => ({ type: dimension }));
  }

  if (customFieldsQueryState.status !== 'success') {
    return [];
  }
  const dimensionCustomFields: Dimension[] = isCustomFieldsFeatureEnabled
    ? customFieldsQueryState.data.customFields.map((customField) => ({
        type: 'customField',
        customFieldId: customField.id,
      }))
    : [];

  return [
    ...ADVANCED_DIMENSIONS.filter(
      (dimension) =>
        !(dimension === 'team' && !isTeamsFeatureEnabled) &&
        !(dimension === 'costCenter' && !isCostCentersFeatureEnabled) &&
        !(
          dimension === 'expenseCategory' && !isExpenseCategoriesFeatureEnabled
        ),
    ).map((dimension) => ({ type: dimension })),
    ...dimensionCustomFields,
  ];
};
